////////////////////
// Template

import { getContrastRatios } from "../../utils/getContrastRatios";

////////////////////
const template = /*html*/ `
    <div class="c-radio-selector">
        <h3 class="c-radio-selector_title || c-text -caption-alt">{{ label }}</h3>
        <div class="c-radio-selector_group">
        <div class="c-radio-selector_group_inner" v-for="(value, index) in values">
            <input
                class="c-form_radio"
                :class="{'-round': isRound, '-color': colors.length && colors[index], '-color-border': hasRadioBorder(colors[index]) }"
                type="radio"
                :id="value + label"
                :name="_uid"
                :value="value"
                v-model="selectedValue"
                @change="onSelect"
            >
            <label v-if="colors.length && colors[index]" class="c-form_radioLabel" :for="value" :style="{ backgroundColor: colors[index]}">
                <span>{{ value }}</span>
            </label>
            <label v-else class="c-form_radioLabel" :id="value + label" >
                <span>{{ value }}</span>
            </label>
            </div>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////

const BACKGROUND_COLOR_HEX = '#F0F2F7';

export default function VueProductRadioSelector() {

    Vue.component("product-radio-selector", {

        template,

        props: {
            label: {
                type: String,
                required: true
            },
            values: {
                type: Array,
                default: () => []
            },
            colors: {
                type: Array,
                default: () => []
            },
            currentValue: {
                type: String,
                required: true
            },
            position: {
                type: Number,
                required: true
            },
            isRound: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                selectedValue: ''
            };
        },

        created() {

        },

        mounted() {
            this.selectedValue = this.currentValue
        },

        methods: {
            /////////////////
            // Callbacks
            /////////////////
            onSelect() {
                this.$emit('onSelect', {
                    position: this.position,
                    value: this.selectedValue
                })
            },

            /////////////////
            // Methods
            /////////////////
            hasRadioBorder(colorHex) {
                if (!colorHex) return false
                const { aaLevelLargeText } = getContrastRatios(BACKGROUND_COLOR_HEX, colorHex)
                return !aaLevelLargeText
            }
        }
    });
}
